import * as React from 'react'
import cn from 'classnames'

type StepDotsProps = {
  totalSteps: number
  currentStep: number
}

// The progress indicator in the modal footer: the active step renders as a wide
// green pill, the remaining steps as muted dots.
export const StepDots = ({ totalSteps, currentStep }: StepDotsProps) => (
  <div className="flex items-center gap-2">
    {Array.from({ length: totalSteps }, (_, index) => {
      const isActive = index + 1 === currentStep

      return (
        <span
          key={index}
          className={cn(
            'h-2.5 rounded-full transition-all',
            isActive ? 'w-8 bg-[#2E9E5D]' : 'w-2.5 bg-[#D7DBE8]',
          )}
        />
      )
    })}
  </div>
)
